module.exports = __webpack_public_path__ + "assets/img/Super-Obvious-Landing-Page-w720.c3ffab19.jpg";